module.exports = __webpack_public_path__ + "img/2019.0fa32adb.svg";